export enum TransferType {
  Full = 'Full',
  Partial = 'Partial',
}
